import { FormViewField } from 'components/FormView';

export default {
  formName: 'SalesOrderEnquiryFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Entity view',
        name: 'EntityView',
        lookupName: 'EntityView',
        size: 'small',
        required: true,
      }
    },
    {
      id: 2,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Sales entity',
        size: 'small',
        name: 'SalesEntity',
        lookupName: 'SalesEntity',
        disabled: false,
        isEntityScoped: true,
        suppressDescription: true
      }
    },
    {
      id: 3,
      type: 'AUTOCOMPLETE_FIELD',
      props: {
        label: 'Status',
        name: 'Status',
        required: false,
        apiPrefs: {
          path: '/CustomTypes/Lookup/SalesOrderStatus/Search',
          method: 'POST',
          params: {
            BatchSize: 20
          }
        },
      }
    },
    {
      id: 4,
      type: 'SELECT_FIELD',
      props: {
        label: 'Finalised/Unfinalised',
        name: 'Finalised',
        defaultValue: 'False',
        options: [
          {
            value: false,
            label: 'Unfinalised',
            default: true
          },
          {
            value: true,
            label: 'Finalised'
          }
        ]
      }
    },
    {
      id: 5,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Warehouse',
        name: 'Warehouse',
        lookupName: 'WarehouseEntity',
        size: 'small',
        required: false
      }
    },
    {
      id: 6,
      type: 'EX_LOOKUP_FIELD',
      visible: true,
      props: {
        label: 'Customer',
        suppressValidation: true,
        isDisplayValue: true,
        name: 'CustomerId',
        size: 'small',
        lookupName: 'Customer'
      }
    },
    {
      id: 7,
      type: 'TEXT_FIELD',
      props: {
        label: 'Customer P/O',
        name: 'CustomerPO',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 4,
      type: 'DATE_FIELD',
      props: {
        label: 'Date range from',
        name: 'FromDate',
        required: false,
        dateFormat: 'DD/MM/YYYY',
        placeholder: 'DD/MM/YYYY',
        nullable: 'true',
        size: 'medium',
        style: {
          display: 'inline-block',
          width: '155px',
          marginRight: '16px'
        }
      }
    },
    {
      id: 5,
      type: 'DATE_FIELD',
      props: {
        label: 'To',
        name: 'ToDate',
        required: false,
        dateFormat: 'DD/MM/YYYY',
        placeholder: 'DD/MM/YYYY',
        nullable: 'true',
        size: 'medium',
        style: {
          display: 'inline-block',
          width: '155px'
        }
      }
    },
  ] as FormViewField[]
};
